<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <SettingsMenu></SettingsMenu>
            <AccountInfo></AccountInfo>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "../reuseable_components/Header.vue";
import SettingsMenu from "./SettingsMenu.vue";
import MainBalance from "./MainBalance.vue";
import AccountInfo from "./AccountInfo.vue";

export default {
  name: "Account",
  components: {
    "app-header": AppHeader,
    SettingsMenu: SettingsMenu,
    MainBalance: MainBalance,
    AccountInfo: AccountInfo,
  },
};
</script>
<style lang="scss">
</style>